function initCustomNameLogic() {
  const BASE_PRICE = 799;
  const PER_CHAR = 249;
  const MIN_CHARS = 1;
  const MAX_CHARS = 14;

  if (!window.__productHasCustomName__) return;

  const variantMap = window.__charVariantMap__ || {};
  const wrappers = document.querySelectorAll('#custom-name-wrapper');

  wrappers.forEach(wrapper => {

    if (wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = true;

    const input = wrapper.querySelector('#custom-name-input');
    const errorMsg = wrapper.querySelector('#custom-name-error');
    const mainPrice = wrapper.querySelector('.custom-main-price');
    const priceDisplay = wrapper.querySelector('#custom-name-price-display');
    const form = input && input.closest('form');

    if (!input || !form) return;

    function charCount(str) {
  if (!str) return 0;

  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
    return [...segmenter.segment(str)].length;
  }

  return [...str].length;
}

    function updateVariantAndPrice() {
      const count = charCount(input.value);
      const variantInput = form.querySelector('[name="id"]');
      if (count === 0) {
        priceDisplay.textContent = '';
        // 👇 ADD THIS
          if (mainPrice) {
            mainPrice.textContent = '₹' + BASE_PRICE;
          }
        if (variantInput) variantInput.value = '';
      } else {
        const total = BASE_PRICE + count * PER_CHAR;
        priceDisplay.textContent = 'Total: ₹' + total.toLocaleString('en-IN');
          // 👇 ADD THIS
          if (mainPrice) {
            mainPrice.textContent = '₹' + total.toLocaleString('en-IN');
          }
        const variantId = variantMap[String(count)];
        if (variantId && variantInput) {
          variantInput.value = variantId;
        }
      }
    }

    // input.addEventListener('input', function () {
    //   const chars = [...input.value];
    //   if (chars.length > MAX_CHARS) {
    //     input.value = chars.slice(0, MAX_CHARS).join('');
    //   }

    //   errorMsg.style.display = 'none';
    //   updateVariantAndPrice();
    // });

    input.addEventListener('input', function () {
  if (charCount(input.value) > MAX_CHARS) {
    const segmenter = new Intl.Segmenter('en', {
      granularity: 'grapheme'
    });

    const chars = [...segmenter.segment(input.value)]
      .slice(0, MAX_CHARS)
      .map(item => item.segment);

    input.value = chars.join('');
  }

  errorMsg.style.display = 'none';
  updateVariantAndPrice();
});

    form.addEventListener('submit', function (e) {
      if (charCount(input.value) < MIN_CHARS) {
        e.preventDefault();
        e.stopImmediatePropagation();
        errorMsg.style.display = 'block';
        input.focus();
        return false;
      }
    });

    const btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        if (charCount(input.value) < MIN_CHARS) {
          e.preventDefault();
          e.stopImmediatePropagation();
          errorMsg.style.display = 'block';
          input.focus();
          return false;
        }
      });
    }
    updateVariantAndPrice(); 
  });
}

document.addEventListener('DOMContentLoaded', initCustomNameLogic);

// Quick view / AJAX reload support
document.addEventListener('click', function () {
  setTimeout(initCustomNameLogic, 300);
});